export default {
  SHOW_EDITOR: '@WS_EDITOR/EDITOR/SHOW_EDITOR',
  HIDE_EDITOR: '@WS_EDITOR/EDITOR/HIDE_EDITOR',
  SET_LOADED_STATUS: '@WS_EDITOR/EDITOR/SET_LOADED_STATUS',
};
